import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { useContext } from 'react'
import ApplicationContext from '@platform/react/context/application'

/**
 * Intended to display the type of the ticket.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellTicketType = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { type: typeKey, submit: { timestamp = '' } = {}, events } = props
  const submitDate = timestamp
    ? intl.getLocaleDate(timestamp, { dateStyle: 'short' })
    : ''
  const [type] = events?.getTicketType?.(typeKey) || []
  const typeName = type?.value

  return (
    <>
      <Typography
        variant={'body2'}
        color={'black'}
        className={classes.row}
        sx={{ fontWeight: 700 }}
      >
        {typeName}
      </Typography>
      <Typography
        variant={'caption'}
        color={'textSecondary'}
        className={classes.row}
      >
        {submitDate}
      </Typography>
    </>
  )
}

export default CellHOC(ListItemCellTicketType)
